import { motion, AnimatePresence } from "framer-motion";
import { LogoMark } from "./Logo";

export const Preloader = ({ done }) => (
  <AnimatePresence>
    {!done && (
      <motion.div
        data-testid="preloader-veil"
        className="fixed inset-0 z-[100] bg-[#F6F4F0] flex flex-col items-center justify-center"
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <LogoMark className="w-14 h-14" />
        </motion.div>
        <motion.p
          initial={{ opacity: 0, letterSpacing: "0.18em" }}
          animate={{ opacity: 1, letterSpacing: "0.5em" }}
          transition={{ duration: 1.05, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="mt-7 font-serif text-sm uppercase text-[#1F1E1B]/90 pl-2"
        >
          PJG Capital Partners
        </motion.p>
        <motion.span
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.1, delay: 0.25, ease: "easeInOut" }}
          className="mt-7 h-px w-44 bg-gradient-to-r from-transparent via-[#1F1E1B] to-transparent"
        />
      </motion.div>
    )}
  </AnimatePresence>
);
